
(() => {
  function formatPrice(value) {
    return Number(value).toLocaleString('en-IN', {
      maximumFractionDigits: 0
    });
  }

  function updateSlider(wrapper) {
    const min = wrapper.querySelector(
      '.custom-price-slider__min'
    );
    const max = wrapper.querySelector(
      '.custom-price-slider__max'
    );
    const progress = wrapper.querySelector(
      '.custom-price-slider__progress'
    );

    if (!min || !max || !progress) return;

    const limit = Number(wrapper.dataset.max) || 1;
    const low = Number(min.value);
    const high = Number(max.value);
    const symbol = wrapper.dataset.currency || '₹';

    const left = (low / limit) * 100;
    const right = (high / limit) * 100;

    progress.style.left = left + '%';
    progress.style.width = (right - left) + '%';

    wrapper.querySelector(
      '.custom-price-slider__min-label'
    ).textContent = symbol + formatPrice(low);

    wrapper.querySelector(
      '.custom-price-slider__max-label'
    ).textContent = symbol + formatPrice(high);
  }

  function applyPriceFilter(wrapper) {
    const nativeInputs = wrapper.querySelectorAll(
      '.custom-price-slider__native input'
    );

    const minSlider = wrapper.querySelector(
      '.custom-price-slider__min'
    );
    const maxSlider = wrapper.querySelector(
      '.custom-price-slider__max'
    );

    if (
      nativeInputs.length < 2 ||
      !minSlider ||
      !maxSlider
    ) return;

    const minimum = Number(minSlider.value);
    const maximum = Number(maxSlider.value);
    const limit = Number(wrapper.dataset.max);

    const minInput = nativeInputs[0];
    const maxInput = nativeInputs[1];

    // Shopify price parameters expect currency-unit values.
    minInput.value = minimum <= 0 ? '' : String(minimum);
    maxInput.value = maximum >= limit ? '' : String(maximum);

    // Update Shopify's native price-range constraints.
    minInput.setAttribute(
      'data-max',
      maxInput.value || String(limit)
    );
    maxInput.setAttribute(
      'data-min',
      minInput.value || '0'
    );

    // Shopify Refresh listens for bubbling input events.
    minInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }

  function initializeSlider(wrapper) {
    if (wrapper.dataset.sliderReady === 'true') return;

    const min = wrapper.querySelector(
      '.custom-price-slider__min'
    );
    const max = wrapper.querySelector(
      '.custom-price-slider__max'
    );

    if (!min || !max) return;

    wrapper.dataset.sliderReady = 'true';

    [min, max].forEach(slider => {
      slider.addEventListener('input', event => {
        // Stop Shopify from filtering during dragging.
        event.stopPropagation();

        const low = Number(min.value);
        const high = Number(max.value);

        if (low > high) {
          if (slider === min) {
            max.value = low;
          } else {
            min.value = high;
          }
        }

        updateSlider(wrapper);
      });

      slider.addEventListener('change', event => {
        event.stopPropagation();

        updateSlider(wrapper);
        applyPriceFilter(wrapper);
      });
    });

    updateSlider(wrapper);
  }

  function initializeAll() {
    document.querySelectorAll(
      '.custom-price-slider'
    ).forEach(initializeSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );
  } else {
    initializeAll();
  }

  // Reinitialize after Shopify AJAX filtering updates.
  const observer = new MutationObserver(mutations => {
    const hasNewSlider = mutations.some(mutation =>
      Array.from(mutation.addedNodes).some(node =>
        node.nodeType === 1 &&
        (
          node.matches?.('.custom-price-slider') ||
          node.querySelector?.('.custom-price-slider')
        )
      )
    );

    if (hasNewSlider) initializeAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
